// initial state
const state = {
  options: {
    type: [
      {label: '普通项目', value: '1'},
      {label: '中台项目', value: '2'},
    ],
    projectProgressLabel: {
      1: '进行中',
      2: '已完成',
    },
    clearFileUploadStatusLabel: {
      1: '待清洗',
      2: '已清洗',
      3: '无需清洗',
    },
  },
}

// getters
const getters = {}

// actions
const actions = {
  getReceiptVirtualProjectTable: ({commit, state}, params) => request.alert('getReceiptVirtualProjectTable', params),
  getReceiptVirtualProjectDetail: ({commit, state}, params) => request.alert('getReceiptVirtualProjectDetail', params),
}

// mutations
const mutations = {}

export const project = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/project/project.store.js